// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore"; // السطر الخاص بقاعدة البيانات
import { getAuth, GoogleAuthProvider } from "firebase/auth"; // السطر الخاص بنظام تسجيل الدخول
import { getStorage } from "firebase/storage"; // إضافة Firebase Storage لرفع الصور

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCimpl8_FFfV-t47AEx-awAjaEkGAMUnUY",
  // ✅ التعديل هنا: استبدل الرابط القديم بدومينك الجديد
  authDomain: "lobabschool.com",
  projectId: "lobab-course",
  storageBucket: "lobab-course.firebasestorage.app",
  messagingSenderId: "425231511343",
  appId: "1:425231511343:web:bd92e77f14e68018ef3bda",
  measurementId: "G-PL750G3XSL"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// تهيئة قاعدة البيانات مع تفعيل التخزين المؤقت المحلي (الكاش السريع جداً)
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() })
});

// تهيئة وإصدار نظام التحقق من المستخدمين
export const auth = getAuth(app);

// إعداد مزود تسجيل الدخول بجوجل
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });

// تهيئة وإصدار نظام تخزين الملفات (لصور المقالات)
export const storage = getStorage(app);